import WebComponent from '../base/WebComponent';

class StepNavItem extends WebComponent {
    props = {
        active: null,
        index: null,
        namespace: null,
        headline: null,
        text: null,
        state: null,
        handler: null
    };

    description() {
        switch (this.props.state) {
            case 1:
                return "Fejl";
            case 2:
                return "Success";
            default:
                return this.props.text;
        }
    }

    // connect component
    connectedCallback() {
        this.render();
    }

    beforeMount() {
        this.classList.add('stepform-nav-item', 'fu-button', 'tertiary__bg', 'quaternary__text');
        if (this.props.active) {
            this.classList.add('active');
        }
    }

    mounted() {
        if (this.props.handler !== null) {
            this.addEventListener('click', () => this.props.handler(this.props.index));
        }
    }
    
    template() {
        return `
            ${this.props.state == 0 ? `<span>${this.props.index + 1}</span>`: ""}
            ${this.props.state !== 0 ? `<${this.props.state == 1 ? 'icon-alert' : 'icon-check'}></${this.props.state == 1 ? 'icon-alert' : 'icon-check'}>`: ""}
        `;
    }
  }
  
  // register component
  customElements.define( 'step-nav-item', StepNavItem );


